import SSVG from './ssvg';

export = SSVG;
